import axios from 'axios';
import store from '../store';

// axios.interceptors.response.use(
//   function(response) { return response; },
//   function(error) {
//       if (error.response) {
//         console.log(error.response);
//         store.commit('showNotification', { text: error.response.data.error, status: 'error' });
//         return Promise.reject(error);
//       }
//   });

// const baseUrl = 'http://192.168.1.8:3000';
const baseUrl = process.env.VUE_APP_ROOT_API;

const state = {
  atividadesVinculos: [],
};

const getters = {
  // Atividades Vinculos
  atividadesVinculos: state => state.atividadesVinculos,
}

const actions = {
  // Atividades Vinculos
  async fetchAtividadesVinculos({ commit }, { idEmpresa, idProjeto }) {
    const response = await axios.get(`${baseUrl}/atividadesvinculos/${idEmpresa}/${idProjeto}`);
    if (response.data.length) {
      commit('setAtividadesVinculos', response.data);
    } else {
      commit('setAtividadesVinculos', []);
    }
  },
  async addAtividadeVinculo({ commit }, atividadeVinculo) {
    const response = await axios.post(`${baseUrl}/atividadesvinculos`, atividadeVinculo);
    commit('newAtividadeVinculo', response.data);
  },
  async deleteAtividadeVinculo({ commit }, atividadeVinculo) {
    let url;

    if (atividadeVinculo.IdAtividadeVinculo) {
      url = `${baseUrl}/atividadesvinculos/1/atividades/${atividadeVinculo.IdAtividadeVinculo}/${atividadeVinculo.IdAtividade}?atividade=${atividadeVinculo.Atividade}`;
    } else {
      url = `${baseUrl}/atividadesvinculos/1/projetos/${atividadeVinculo.IdProjeto}/${atividadeVinculo.IdAtividade}?projeto=${atividadeVinculo.Projeto}`;
    }

    await axios.delete(url);
    commit('removeAtividadeVinculo', atividadeVinculo.IdAtividade);
  },
}

const mutations = {
  // Atividades Vinculos
  setAtividadesVinculos: (state, atividadesVinculos) => state.atividadesVinculos = atividadesVinculos,
  newAtividadeVinculo: (state, atividadeVinculo) => state.atividadesVinculos.push(atividadeVinculo),
  removeAtividadeVinculo: (state, id) => state.atividadesVinculos = state.atividadesVinculos.filter(av => av.IdAtividade !== id)
}

export default {
  state,
  getters,
  actions,
  mutations
}